import React, { useContext } from "react";
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";
import { SkeletonAnnotated } from "lib/components";

import { QuickLink } from "app/reports";

import { TwoColumnLayout } from "layout/private/components";

import { storageHelper } from "lib/helpers";

import { OperatorActivityList } from "app/userManagement/modules/operator/features/index";
import { ProviderActivityList } from "app/userManagement/modules/provider/features/index";
import { AdminActivityList } from "./admin/features";

const { userKey } = constant;
const { admin, operator, provider } = userKey;

const ActivityList = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");

  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === admin) {
      return <AdminActivityList />;
    }
    if (role === operator) {
      return <OperatorActivityList />;
    }
    if (role === provider) {
      return <ProviderActivityList />;
    }
    return null;
  };

  const getSecondaryComponent = () => {
    return (
      <>
        <QuickLink />
      </>
    );
  };

  return <TwoColumnLayout primary={getComponent(currentUserRole)} secondary={getSecondaryComponent()} />;
};

export default ActivityList;
